// TinyMCE settings for the LexiQamus CMS admin page form (lab.lexiqamus.com uses TinyMCE 5).
export const TINYMCE_VERSION = '5.10.9'
export const TINYMCE_SELF_HOSTED_BASE_URL = `https://cdn.jsdelivr.net/npm/tinymce@${TINYMCE_VERSION}`
